import Service from "@/pages/administrer/configuration/services/Service.vue";
import CreateService from "@/pages/administrer/configuration/services/CreateService.vue";
import ShowService from "@/pages/administrer/configuration/services/ShowService.vue";

export default [
    {
        path: 'services',
        meta: { permissions: ["view_recipient_service"] },
        name: "AdminConfigService",
        component: Service
    },
    {
        path: 'services/create',
        meta: { permissions: ["create_recipient_service"] },
        name: "AdminConfigCreateService",
        component: CreateService
    },
    {
        path: 'services/:id/show',
        meta: { permissions: ["view_any_recipient_service"] },
        name: "AdminConfigShowService",
        component: ShowService
    },
]